import * as React from "react"
import RankingBox from "./ranking-box"
import Button from "./button"

export default function HomeProjects({ projectStats }) {
  return (
    <>
      <div>
        <h2 className="text-center uppercase tracking-widest font-bold text-2xl lg:text-3xl mt-10 mb-5 lg:mt-16 lg:mb-8">
          At a Glance
        </h2>
      </div>
      <div>
        <h3 className="text-center uppercase tracking-widest font-bold text-lg lg:text-xl my-6 lg:my-12">
          Project Status
        </h3>
      </div>
      <div className="mb-[60px] px-5">
        <div className="grid sm:grid-cols-2 grid-cols-1 gap-4 mx-auto max-w-[1200px]">
          <RankingBox
            number={projectStats.status.proposed}
            text="Projects Proposed"
            subtext={`${Math.round(
              (projectStats.status.proposed / projectStats.total) * 100
            )}% of total projects`}
            numberBgColor="#E2C744"
            boxType="primary"
          />
          <RankingBox
            number={projectStats.status.approved}
            text="Projects Approved"
            subtext={`${Math.round(
              (projectStats.status.approved / projectStats.total) * 100
            )}% of total projects`}
            numberBgColor="#19a1db"
            boxType="primary"
          />
          <RankingBox
            number={projectStats.status.funded}
            text="Projects Funded"
            subtext={`${Math.round(
              (projectStats.status.funded / projectStats.total) * 100
            )}% of total projects`}
            numberBgColor="#3FA98A"
            boxType="primary"
          />
          <RankingBox
            number={projectStats.status.completed}
            text="Projects Completed"
            subtext={`${Math.round(
              (projectStats.status.completed / projectStats.total) * 100
            )}% of total projects`}
            numberBgColor="#FF5E00"
            boxType="primary"
          />
        </div>
      </div>
      <div>
        <h3 className="text-center uppercase tracking-widest font-bold text-lg lg:text-xl my-6 lg:my-12">
          Project Type
        </h3>
      </div>
      <div className="mb-[60px] px-5">
        <div className="grid sm:grid-cols-2 grid-cols-1 gap-4 mx-auto max-w-[1200px]">
          <RankingBox
            number={projectStats.types.offRoadTrailOrPath}
            text="Offroad Trails"
            subtext={`${Math.round(
              (projectStats.types.offRoadTrailOrPath / projectStats.total) * 100
            )}% of total projects`}
            numberBgColor="#AE9269"
            boxType="primary"
          />
          <RankingBox
            number={projectStats.types.protectedBikeLaneOrSidePath}
            text="Protected Bike Lanes"
            subtext={`${Math.round(
              (projectStats.types.protectedBikeLaneOrSidePath /
                projectStats.total) *
                100
            )}% of total projects`}
            numberBgColor="#AE9269"
            boxType="primary"
          />
          <RankingBox
            number={projectStats.types.otherBikeway}
            text="Other Bikeways"
            subtext={`${Math.round(
              (projectStats.types.otherBikeway / projectStats.total) * 100
            )}% of total projects`}
            numberBgColor="#AE9269"
            boxType="primary"
          />
          <RankingBox
            number={projectStats.types.otherFacility}
            text="Other Bike Facilities"
            subtext={`${Math.round(
              (projectStats.types.otherFacility / projectStats.total) * 100
            )}% of total projects`}
            numberBgColor="#AE9269"
            boxType="primary"
          />
        </div>
      </div>
      <div className="flex justify-center my-[60px]">
        <Button
          link={"/project-list"}
          text="Explore All Projects"
          type="small"
          className="mb-4"
          color="blue"
        />
      </div>
    </>
  )
}
